<template>
  <div class="modal hide fade in" id="modalSolicitud" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title label-black">Registro de Datos del Solicitante</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-12 padding">
            <div class="row">
              <div class="form-group col-6">
                <label class="label-black">Fecha Solicitud</label>
                <input type="date" class="form-control" v-model="FechaSolicitud">
              </div>
              <div class="form-group col-6 text-center">
                <input type="checkbox" class="form-check-input" id="autorizado_Check" v-model="Autorizado">
                <label for="autorizado_Check" class="form-check-label label-black">Usuario Autorizado</label>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-4">
                <label class="label-black">Nombre</label>
                <input type="text" class="form-control" v-model="SolicitudesPublica.Nombre">
              </div>
              <div class="form-group col-4">
                <label class="label-black">Apellido Paterno</label>
                <input type="text" class="form-control" v-model="SolicitudesPublica.ApellidoPaterno">
              </div>
              <div class="form-group col-4">
                <label class="label-black">Apellido Materno</label>
                <input type="text" class="form-control" v-model="SolicitudesPublica.ApellidoMaterno">
              </div>
              
            </div>
            <div class="row">
              <div class="form-group col-6">
                <label class="label-black">Tipo Identificación</label>
              
                <TipoIdentificacion v-on:valorParaElPadre="cambioDeTipo"
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                    :idDelInput="'filtroDeBusqueda_TipoIdentificacion'"
                                    :parametros="parametros_TipoIdentificacion"
                                    :valorDefinido="parametros_TipoIdentificacion.tipoIdentificacionId"
                                    :key="parametros_TipoIdentificacion.tipoIdentificacionId">
                </TipoIdentificacion>
              </div>
              <div class="form-group col-6">
                <label class="label-black">No. Identificación</label>
                <input type="text" class="form-control" v-model="SolicitudesPublica.NumeroIdentificacion">
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12">
                <label class="label-black">Observaciones:</label>
                <textarea type="text" class="form-control" rows="2" v-model="Observaciones" placeholder="Escriba una observación si es necesario"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="botonCancelar" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-custom" id="botonRegistrar">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import moment from 'moment'

export default {
    components: {
        TipoIdentificacion : catalogos.PJ.C038TiposIdentificacion
    },
    data(){
        return{
            enumeraciones,
            SolicitudesPublica: {
                Nombre: "",
                ApellidoPaterno: "",
                ApellidoMaterno: "",
                NumeroIdentificacion: ""
            },
            Observaciones: "",
            parametros_TipoIdentificacion: {
                    tipoIdentificacionId: -1
            },
            FechaSolicitud : moment().format('YYYY-MM-DD'),
            Autorizado: true
        }
    },
    props:{
      inventarioDocumentoId: {
        type: Number,
        default: 0
        },
      AreaDatos: Object,
      volumenSolicitud: Array,
      incidenteSolicitud: Array,
      terceriaSolicitud: Array
    },
    methods: {
        cambioDeTipo(datos){
            this.parametros_TipoIdentificacion.tipoIdentificacionId = parseInt(datos.target.value);
        },
        Mostrar: function () {
            $('#modalSolicitud').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonRegistrar').unbind('click').click(this.RegistraSolicitud);
        },
        ModalClose: function(){
            $('#modalSolicitud').modal('hide');
            this.$emit('dialogo', false);
        },
        RegistraSolicitud: function(){
            if(this.ValidaDatos())
            {
            var peticion= {
                
                "SolicitudesPublicas": {
                    "Nombre": this.SolicitudesPublica.Nombre,
                    "ApellidoPaterno": this.SolicitudesPublica.ApellidoPaterno,
                    "ApellidoMaterno": this.SolicitudesPublica.ApellidoMaterno,
                    "TipoIdentificacion": { "TipoIdentificacionId" :this.parametros_TipoIdentificacion.tipoIdentificacionId},
                    "NumeroIdentificacion": this.SolicitudesPublica.NumeroIdentificacion
                  },
                "SolicitudesDocumentos":{
                    "InventarioDocumentoId": this.inventarioDocumentoId,
                    "FechaRegistro": this.FechaSolicitud,
                    "TipoEstatusSolicitud": {"TipoEstatusSolicitudDocumentoId": 2},
                    "ObservacionesArchivo": this.Observaciones,
                    "ObservacionesJuzgado" : ""
                  },
                VolumenesEnSolicitud: this.GeneramosListaVolumenes(),
                IncidentesEnSolicitud: this.GeneramosListaIncidentes(),
                TerceriasEnSolicitud: this.GeneramosListaTercerias(),
                "Autorizado": this.Autorizado
            };
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.NuevaSolicitudPublicaArchivo, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    $('#modalSolicitud').modal('hide');
                    this.$emit('dialogo', false);
                }
                else
                {
                    this.$emit('dialogo', false);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta("Se ha generado la Solicitud del Documento", null, null);
                    $('#modalSolicitud').modal('hide');
                }
                comun.SeEstaCargandoInformacion(false);

            }).catch(excepcion => {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                $('#modalSolicitud').modal('hide');
                //Aqui llamamos rutina de impresion de reporte
                this.$emit('dialogo', false);
            });

            //$('#modalSolicitud').modal('hide');
            //this.$emit('dialogo', false);
            }
        },
        ValidaDatos(){
            if(this.SolicitudesPublica.Nombre =="" || this.SolicitudesPublica.Nombre==null)
            {
                comun.mensajeDeAlerta("Completar Nombre del Solicitante.", null, null);
                return false;
            }
            if(this.SolicitudesPublica.ApellidoPaterno =="" || this.SolicitudesPublica.ApellidoPaterno==null)
            {
                comun.mensajeDeAlerta("Completar Apellido Paterno.", null, null);
                return false;
            }
            if(this.parametros_TipoIdentificacion.tipoIdentificacionId == -1 )
            {
                comun.mensajeDeAlerta("Seleccionar un Tipo de Identificación.", null, null);
                return false;
                }
            if(this.SolicitudesPublica.NumeroIdentificacion =="" || this.SolicitudesPublica.NumeroIdentificacion==null)
            {
                comun.mensajeDeAlerta("Completar Numero de Identificación.", null, null);
                return false;
                }
            return true;
        },
        GeneramosListaVolumenes(){
          var lista= [];
          this.volumenSolicitud.forEach(function (volumenId){
            lista.push({
              SolicitudDocumentoId: 0,
              VolumenId: volumenId.VolumenId})
            });
          return lista;
        },
        GeneramosListaIncidentes(){
        var lista= [];
        this.incidenteSolicitud.forEach(function (incidenteId){
          lista.push({
            SolicitudDocumentoId: 0,
            IncidenteId: incidenteId})
          });
        return lista;
        },
        GeneramosListaTercerias(){
          var lista= [];
          this.terceriaSolicitud.forEach(function (terceriaId){
            lista.push({
              SolicitudDocumentoId: 0,
              TerceriaId: terceriaId})
            });
        return lista;
        }
    },
    mounted(){
        this.Mostrar();

    }
}
</script>

<style scoped>
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none;
    overflow: hidden;
    outline: 0;
  }

  input[type="text"]:read-only {
    background: #f3f3f3;
  }

  input[type="text"]:read-only:focus {
      color: #fff;
  }
  .modal-content {
      background-color:  #7e7f74;
  }
  .modal-header {
        background-color:  #007573;
  }
  .label-black {
        color: black;
  }
  .btn-custom {
        background-color: #004746;
        color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/DatosPublico.vue